module.exports = {
  TEARDOWN_REQUIRED: 'The proxyUrl was set after a session or publisher were created. Please tear down the session and all publishers and try again',
  ALREADY_SET: 'The proxyUrl has already been set. Setting it again will not have any effect.',
  DEPRECATED_METHOD: 'Setting the proxyUrl via initSession has been deprecated because it can result in some HTTPS traffic going directly to OpenTok. Please tear down the session and use OT.setProxyUrl() instead.',
};
